import { LanguageSwitcher } from './components/LanguageSwitcher';
import { useTranslation } from './hooks/useTranslation';

export { LanguageSwitcher, useTranslation };
